import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Form, Grid } from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'
import { FormTitle } from '../../../commonComponents/FormTitle'
import {updateDafferedPayment} from '../../actions/partiesTabAction'
import {saveDafferedPayment} from '../../api/getGBForm'

const DeferredPayment = () => {
  const dispatch = useDispatch()

  const isFormEnabled = false
  const dan1 = useSelector((state) => state.Actor.dan1) || ''
  const dan2 = useSelector((state) => state.Actor.dan2) || ''

  return (
    <Form.Group className='float-container'>
      <FormTitle title='Deferred Payment' boxNumber='2/6'></FormTitle>

      <Grid>
        <Grid.Row style={{justifyContent:'space-between'}}>
          <Grid.Column width="7" className='divFormFeild border-bottom b-brr-5 b-trr-5 b-blr-5 b-tlr-5'>
            <label>DAN1</label>
            <InputField
              isLabel={false}
              id={`DAN1`}
              type='text'
              value={dan1}
              className={'field-bg'}
              clearInput={false}
              clearable
              onChange={(value) => dispatch(updateDafferedPayment({ "dan1": value }))}
              onBlur={(value) => saveDafferedPayment({ "dan1": dan1 || " " })}
              disabled={isFormEnabled}
            />
          </Grid.Column>
          <Grid.Column width="7" className='divFormFeild border-bottom b-brr-5 b-trr-5 b-blr-5 b-tlr-5'>
            <label>DAN2</label>
            <InputField
              isLabel={false}
              id={`DAN2`}
              type='text'
              value={dan2}
              className={'field-bg'}
              clearInput={false}
              clearable
              onChange={(value) => dispatch(updateDafferedPayment({ "dan2": value }))}
              onBlur={(value) => saveDafferedPayment({ "dan2": dan2 || " " })}
              disabled={isFormEnabled}
            />
          </Grid.Column>

        </Grid.Row>
      </Grid>
    </Form.Group>
  )
}

export default React.memo(DeferredPayment)
